/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/WinAnimators/CardBounceWinAnimator',[
        'pixi',
        'CardUI/WinAnimators/BaseWinAnimator',
        'Arkadium/GameEngine/Core/EngineManagers',
        'Arkadium/GameEngine/Scenes/Nodes/SpriteNode',
        'Arkadium/GameEngine/Maths/Vector2',
        'Arkadium/GameEngine/Tween/Tween',
        'util/Random',
        'absolute/audiomanager'
    ],
    function (PIXI, BaseWinAnimator, EngineManagers, SpriteNode, Vector2, Tween, Random, AudioManager) {
    "use strict";

    var AnimationStateEnum =
    {
        None: 0,
        SpawnCards: 1,
        Done: 2
    };

    var scale = 1/60;

    var x3to2 = function (x) {
        return (x / scale) + EngineManagers.UI.width * 0.5;
    };

    var y3to2 = function (y) {
        return (y / -scale) + EngineManagers.UI.height * 0.5;
    };

    var x2to3 = function (x) {
        return (x - EngineManagers.UI.width * 0.5) * scale;
    };

    var y2to3 = function (y) {
        return (y - EngineManagers.UI.height * 0.5) * -scale;
    };

    var CardBounceWinAnimator = function (supplyView) {
        this.initCardBounceWinAnimator(supplyView);
    };

        CardBounceWinAnimator.prototype = Object.create(BaseWinAnimator.prototype);
        CardBounceWinAnimator.prototype.constructor = CardBounceWinAnimator;

    CardBounceWinAnimator.prototype.initCardBounceWinAnimator = function (supplyView) {
        BaseWinAnimator.call(this, supplyView);

        this.numberOfCardFallen = 0;
        this.numberOfCardsFinished = 0;
        this.totalNumberOfCards = 0;
        this.cardSpawnDelay = 0.0;
        this.cardLayer = 0;
        this.animationState = AnimationStateEnum.None;

    };

    CardBounceWinAnimator.prototype.ShouldStartDuringCardMovement = function ()
    {
        return false;
    };

    CardBounceWinAnimator.prototype.BeginAnimation = function (/*Action*/ endAnimationCallback, /*Card*/ lastCardDropped, /*Pile*/ lastPileDroppedOnto, /*bool*/ dragging)
    {

        this.numberOfCardsFallen = 0;
        this.numberOfCardsFinished = 0;
        this.totalNumberOfCards = this.SupplyView.CardSupply.GetCardList().length;
        this.cardSpawnDelay = 1.2;

        BaseWinAnimator.prototype.BeginAnimation.call(this, endAnimationCallback, lastCardDropped, lastPileDroppedOnto, dragging);

        this.animationTexture = new PIXI.RenderTexture(EngineManagers.UI.width, EngineManagers.UI.height);
        this.animationSprite = new PIXI.Sprite(this.animationTexture);
        this._animationContainer.addChild(this.animationSprite);

        this.cardContainer = new PIXI.DisplayObjectContainer();

        this._animationContainer.UpdateInternal = function (time) {

            for (var i = 0; i < this.cardContainer.children.length; i++) {
                if (this.cardContainer.children[i] instanceof BouncingCardNode) {
                    this.cardContainer.children[i].Update(time);
                }
            }

            this.animationTexture.render(this.cardContainer, null, false);
            this._animationContainer.children[0].texture.baseTexture.dirty();

        }.bind(this);

        AudioManager.playSound('winBounce');

        // Set the animation state to get this thing going
        this.animationState = AnimationStateEnum.SpawnCards;
    };

    CardBounceWinAnimator.prototype.UpdateEndingAnimation = function (/*object*/ o, /*EventArgs*/ time)
            {
                // ---- Check to see if the animation should finish due to user input or change of viewstate ----
                if (this._hasUserClicked)
                {
                    this.PauseEndingAnimation();
                    return;
                }

                // Check if all cards have finished animating
                if (this.numberOfCardsFinished >= this.totalNumberOfCards)
                {
                    this.animationState = AnimationStateEnum.Done;
                }

                // ---- Handle individual animation states ----
                if (this.animationState == AnimationStateEnum.SpawnCards)
                {
                    this.animationState = AnimationStateEnum.None;

                    // Identify which cards are to fall next
                    var /*CardView*/ card;
                    if (this.SupplyView.CardSupply.GetCardList().length > 52)
                    {
                        var /*Pile*/ pile = this.SupplyView.CardSupply.GetPile("Foundation" + (this.numberOfCardsFallen%8));
                        card = this.SupplyView.GetCardView(pile.NthFromTop(Math.floor(1 + this.numberOfCardsFallen/8)));
                    }
                    else
                    {
                        var /*Pile*/ pile = this.SupplyView.CardSupply.GetPile("Foundation" + (this.numberOfCardsFallen%4));
                        card = this.SupplyView.GetCardView(pile.NthFromTop(Math.floor(1 + this.numberOfCardsFallen/4)));
                    }

                    // Make the bouncing card node!
                    var bouncingCardNode = new BouncingCardNode(this, card);
                    this.cardContainer.addChild(bouncingCardNode);
                    bouncingCardNode.Layer = this.cardLayer;
                    bouncingCardNode.TriggerSpawn();
                    this.cardLayer++;

                    // Make the cardviews themselves invisible, as they have been replaced by a 3D bouncing card
                    card.Animating = true;
                    //card.Visible = false;

                    // Increment the counter for the number of cards fallen, and decrease the spawn rate (if necessary)
                    this.numberOfCardsFallen++;

//#if !ARM
                    switch (this.numberOfCardsFallen)
                    {
                        case 2:
                            this.cardSpawnDelay -= 0.3;
                            break;
                        case 5:
                            this.cardSpawnDelay -= 0.4;
                            break;
                        case 10:
                            this.cardSpawnDelay -= 0.4;
                            break;
//                    case 15:
//                        cardSpawnDelay -= 0.4f;
//                        break;
                    }
//#endif


                    // Wait the prescribed amount of time before transitioning back into SpawnCards state to spawn the next card
                    if (this.numberOfCardsFallen < this.totalNumberOfCards)
                    {
                        Tween.Start(this.SupplyView).Wait(this.cardSpawnDelay).Then().Call(function () { this.animationState = AnimationStateEnum.SpawnCards;}.bind(this));
                    }
                }
                if (this.animationState == AnimationStateEnum.Done)
                {
                    this.animationState = AnimationStateEnum.None;
                    Tween.Start(this.SupplyView.GameContainer).Wait(0.5 ).Then().Call(this.PauseEndingAnimation.bind(this));
                }
            };

    CardBounceWinAnimator.prototype.PauseEndingAnimation = function () {
        this.FinishEndingAnimation();
    };

    CardBounceWinAnimator.prototype.FinishEndingAnimation = function ()  {
        if (!this._hasAnimationStarted) return;

        AudioManager.stopSound("winBounce");

        BaseWinAnimator.prototype.FinishEndingAnimation.call(this);

    };

    CardBounceWinAnimator.prototype.EndAnimation = function ()
        {
            this.FinishEndingAnimation();
        };

    CardBounceWinAnimator.prototype.IsAnimationRunning = function ()
        {
            return this._hasAnimationStarted && !this._hasUserClicked && this.numberOfCardsFinished < this.totalNumberOfCards;
        };

    CardBounceWinAnimator.prototype.DidStartAnimation = function ()
        {
            return this._hasAnimationStarted;
        };

    CardBounceWinAnimator.prototype.ShouldShowEndingPopup = function ()
        {
            return this._hasAnimationStarted && (this._hasUserClicked || this.numberOfCardsFinished >= this.totalNumberOfCards);
        };

        // ---- Methods for handling the case in which players use input to skip/end the win animation ----

    CardBounceWinAnimator.prototype.StopAnimationPointEvent = function (/*PointEvent*/ pointEvent)
        {
            this.DoClickEnding();
        };

    CardBounceWinAnimator.prototype.StopAnimationKeyEvent = function (/*KeyboardEvent*/ keyboardEvent)
        {
            /*if (keyboardEvent.Key == VirtualKey.Enter && keyboardEvent.Pressed)
            {
                DoClickEnding();
            }*/
        };

    CardBounceWinAnimator.prototype.DoClickEnding = function ()
        {
            if (this.animationState == AnimationStateEnum.None)
            {
                this._hasUserClicked = true;
            }
        };

    CardBounceWinAnimator.prototype.IncrementNumberCardsFinished = function ()
        {
            if (this.numberOfCardsFinished >= 51) {
                setTimeout(function () {
                    this.numberOfCardsFinished++;
                }.bind(this), 4000);
            }
            else {
                this.numberOfCardsFinished++;
            }
        };

    var BouncingCardNode = function (animator, cardView) {
        this.initBouncingCardNode(animator, cardView);
    };

    BouncingCardNode.prototype.contstructor = BouncingCardNode;
    BouncingCardNode.prototype = Object.create(SpriteNode.prototype);

    BouncingCardNode.prototype.initBouncingCardNode = function (animator, cardView) {
        SpriteNode.call(this);

        this.cardAnimator = animator;
        this.cardView = cardView;

        this.PRNG = new Random(18);
        this.paused = false;
        this.cardNode = null;
        this.xDest = 0.0;
        this.bounceFloor = 0.0;
        this.cardScale = 0.0;
        this.bounceHeight = 0.0;


    };

        // Called when the animation is paused
    BouncingCardNode.prototype.PauseAnimation = function ()
    {
        this.paused = true;
    };

        // Update function for bouncing card nodes
    BouncingCardNode.prototype.UpdateInternal = function (/*GameTime*/ time)
    {
        if (!this.paused)
        {
            this.UpdatePosition();
        }

        if (this.cardNode != null && this.Visible) {}

        SpriteNode.prototype.UpdateInternal.call(time);
    };

    BouncingCardNode.prototype.UpdatePosition = function ()
    {
        var x3 = x2to3(this.x),
            y3 = y2to3(this.y);
        if (x3 > 20 || x3 < -40 || y3 > 20 || y3 < -20)
        {
            this.parent.removeChild(this);
            return;
        }

        x3 += 0.2 * ((this.xDest - 10) / 10);

        if (y3 >= this.bounceFloor)
        {
            y3 -= 0.3 * this.bounceHeight;
            this.bounceHeight += 0.05;
            this.cardScale += 0.001;
            this.scale.x = this.scale.y = this.cardScale;
        }
        else
        {
            this.bounceFloor -= 0.5;
            this.bounceHeight = -1 - (this.xDest / 20);
        }

        this.x = x3to2(x3);
        this.y = y3to2(y3);
    };

        /*
         if (X > 20 || X < -40 || Y > 20 || Y < -20)
         {
         Parent.RemoveChild(this);
         return;
         }

         X += 0.2f * ((xDest - 10) / 10);

         if (Y >= bounceFloor)
         {
         Y -= (0.3f * bounceHeight);
         bounceHeight += 0.05f;
         cardScale += 0.001f;
         Scale = new Vector3(cardScale, cardScale, 1);
         }
         else
         {
         bounceFloor -= 0.5f;
         bounceHeight = -1 - (xDest / 20);
         }
         */

        // Called to trigger the actual creation of the bouncing card node
    BouncingCardNode.prototype.TriggerSpawn = function ()
    {

        this.cardNode = this.cardView; //Sprite3DNode.FromSpriteNode(cardView.CardFront, this, Scene.GetCamera("additionalCamera"));
        var position = this.cardNode.parent.toGlobal(this.cardNode.position);
        this.x = position.x;
        this.y = position.y;
        this.cardNode.x = 0;
        this.cardNode.y = 0;
        this.addChild(this.cardNode);
        this.SetStartingValues();
        AudioManager.playSound("pickupCard");
        this.cardAnimator.IncrementNumberCardsFinished();
    };

    BouncingCardNode.prototype.SetStartingValues = function ()
    {
        var range = this.PRNG.Next(2);
        this.xDest = range == 0 ? this.PRNG.Next(8) : this.PRNG.Next(8, 12);
        this.bounceFloor = -6.5;
        this.bounceHeight = -0.5;
        this.cardScale = 1;
    };

        /*
         var range = PRNG.Next(2);
         xDest = range == 0 ? PRNG.Next(8) : PRNG.Next(12,20);
         bounceFloor = -12.5f;
         bounceHeight = -0.5f;
         cardScale = 1f;
         */

    return CardBounceWinAnimator;

});
